export default function capitalizeFirstLetter(params: string) {
	return params.charAt(0).toUpperCase() + params.slice(1);
}
